// "success", "processing", "error", "default", "warning"
export enum BadgeStatusEnum {
  SUCCESS = 'success',
  PROCESSING = 'processing',
  ERROR = 'error',
  DEFAULT = 'default',
  WARNING = 'warning',
}
